<template>
  <v-navigation-drawer
      id="core-navigation-drawer"
      v-model="drawer"
      :dark="barColor !== 'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)'"
      dark
      mobile-break-point="960"
      app
      :expand-on-hover="expandOnHover"
      :mini-variant="miniVariant"
      src="https://www.yobee.it/wp-content/uploads/2019/10/slide-1-main.png"
  >
    <template v-slot:img="props">
      <v-img
          :gradient="`to bottom, ${barColor}`"
          v-bind="props"
      />
    </template>
    <v-list dense nav class="py-1">
      <v-list-item @click="miniVariant=!miniVariant">
        <v-list-item-avatar tile>
          <v-img
              :src="require('../../assets/images/yobee-logo-y.png')"
              contain
              position="left"
              max-height="40px"
          ></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-img
              :src="require('../../assets/images/yobee-logo-text.png')"
              contain
              position="left"
              max-height="30px"
          ></v-img>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-divider class="mb-1"/>

    <v-list dense nav>

      <v-list-item link active-class="primary" to="/">
        <v-list-item-icon>
          <v-icon>mdi-view-dashboard</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>Dashboard</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link active-class="primary" to="/user">
        <v-list-item-icon>
          <v-icon>mdi-account-cog</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>Account</v-list-item-title>
        </v-list-item-content>
      </v-list-item>


      <v-list-item link active-class="primary" to="/invoices">
        <v-list-item-icon>
          <v-icon>mdi-file-document</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>Fatturazione</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link active-class="primary" href="mailto:info@yobee.it" target="_blank">
        <v-list-item-icon>
          <v-icon>mdi-email-edit</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>Contattaci</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <template v-slot:append>
      <div class="pa-2">
        <v-btn color="default" block @click="logout">Esci</v-btn>
      </div>
    </template>

  </v-navigation-drawer>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "MainDrawer",
  data: () => ({
    miniVariant: false,
    expandOnHover: false,
  }),
  computed: {
    ...mapState(['barColor', 'barImage']),
    drawer: {
      get() {
        return this.$store.state.drawer
      },
      set(val) {
        this.$store.commit('SET_DRAWER', val)
      },
    },
  },
  methods: {
    logout() {
      this.$store.commit('logout');
      this.$router.replace('login')
    }
  }
}
</script>

<style scoped>
.v-list--nav .v-list-item {
  padding: 0;
}

/*.v-navigation-drawer--mini-variant{*/
/*    width: 70px!important;*/
/*}*/
</style>
